import React from 'react';

const CTituloTabla = ({tituloSeccion}) => {
  return (
    
    <div>
      <h3 className="tituloTablaMain">
        {tituloSeccion}
      </h3>
    </div>
  
  );
};

export default CTituloTabla;